import {
  ListAchievements,
  UpdateAchievements,
  UserAchievementPassedDevelopmentPlan,
  UserAchievementPassedFirstCourse,
  UserAchievementUsedAppFirstTime,
  UserAchievementExtraDevelopmentPlan,
} from './Request';

export const fetchAchievements = async () => {
  const achievementsObject = await ListAchievements();

  return { achievementsObject };
};

export const updateAchievement = async ({ id, name }) => {
  const status = await UpdateAchievements({ id, name });

  return status;
};

export const fetchUserAchievements = async ({ userId }) => {
  const promises = [];

  promises.push(UserAchievementPassedDevelopmentPlan({ userId }));
  promises.push(UserAchievementPassedFirstCourse({ userId }));
  promises.push(UserAchievementExtraDevelopmentPlan({ userId }));
  promises.push(UserAchievementUsedAppFirstTime({ userId }));

  const response = await Promise.all(promises);

  return response;
};

export default { fetchAchievements, updateAchievement, fetchUserAchievements };
